<template>
    <div class="cinemaMovieWrap">
        <!-- <nav-bar></nav-bar> -->
        <div class="cinemaInfo fr ac">
            <div class="basicInfo fc jsa">
                <h3>{{cinemaInfo.name}}</h3>
                <p>{{cinemaInfo.address}}</p>
            </div>
            <div @click="viewLocation(cinemaInfo.lat,cinemaInfo.lon, cinemaInfo.name, cinemaInfo.address)" class="locationIco center">
                <img src="../../../static/imgs/movie/icon_address.png" alt />
            </div>
        </div>
        <div class="scrollWrap">
            <div
                v-if="hotMovieList.length && hotMovieList[activeIdx].logo"
                :style="'background-image: url('+hotMovieList[activeIdx].logo+'_300x300);'"
                class="scrollBg"
            ></div>
            <div v-if="hotMovieList.length" id="movieScroll" class="movieScroll">
                <div class="movieWrap">
                    <img
                        ref="movieItem"
                        v-for="(item, index) in hotMovieList"
                        :key="index"
                        :class="index == activeIdx ? 'activeMovieItem' :  'movieItem'"
                        :src="item.logo + '_300x300'"
                        @click="selectMovie(index)"
                    />
                </div>
            </div>
        </div>
        <div
            v-if="hotMovieList != 'undefined' && hotMovieList.length >= 1"
            class="selectedMoveie fc ac jsa"
        >
            <h3>
                {{hotMovieList[activeIdx].name}}
                <span
                    v-show="hotMovieList[activeIdx].rating > 0"
                >{{hotMovieList[activeIdx].rating}}</span>
            </h3>
            <span
                class="grey"
            >{{hotMovieList[activeIdx].state}} | {{hotMovieList[activeIdx].duration}}分钟 | {{hotMovieList[activeIdx].showmark ? hotMovieList[activeIdx].showmark : '暂无'}}</span>
        </div>
        <div class="dateScroll">
            <span
                @click="selectDate(index)"
                :class="index == selectedIdx ? 'active' : 'fade'"
                v-for="(item, index) in dateList"
                :key="item"
            >{{item | formatDate}}</span>
        </div>
        <div
            @click="goSelectSeat(item)"
            class="sessionList fr ac jsb"
            v-for="item in sessionList"
            :key="item.id"
        >
            <div class="timeInfo fc jc">
                <span class="playtime">{{item.playtime | formatTime}}</span>
                <span class="closetime grey mt20">{{item.closetime | formatTime}}散场</span>
            </div>
            <div class="movieInfo fc jc">
                <span class="edition">{{item.edition}}</span>
                <span class="room grey mt20 ellipsis">{{item.roomname}}</span>
            </div>
            <div v-if="item.sdremark || item.sdid" class="priceInfo fc jc">
                <span class="price">{{item.sdprice / 100}}元</span>
                <span class="oriPrice grey">原价 {{item.price / 100}}元</span>
                <span class="sales">{{item.sdremark}}</span>
            </div>
            <!-- <span v-else class="price">{{item.price / 100}}元</span> -->
            <span class="price" v-if="!item.sdremark && !item.sdid && item.areaMinprice">￥{{ item.areaMinprice / 100 }}起</span>
            <span class="price" v-if="!item.sdremark && !item.sdid && !item.areaMinprice && item.price">￥{{ item.price / 100 }}</span>
            <button class="btn">购票</button>
        </div>
        <div v-show="!sessionList.length" class="noSession fc ac jsa">
            <span>今日无可观影场次</span>
            <button @click="viewOtherDate" v-show="dateList && dateList.length > 1">看看其它日期</button>
        </div>
    </div>
</template>

<script>
import { Toast, Indicator } from "mint-ui";
import navBar from "../../components/common/navBar.vue";
export default {
    data() {
        return {
            movieid: this.$route.query.movieid
                ? this.$route.query.movieid
                : "826862",
            cinemaid: this.$route.query.cinemaid,
            citycode: this.$route.query.citycode
                ? this.$route.query.citycode
                : this.getLocal("selectedCityCode"),
            cinemaInfo: {},
            dateList: [],
            selectedIdx: 0, //选中日期的索引
            sessionList: [],
            hotMovieList: [],
            activeIdx: 0, //选中电影的索引
            screenWidth: document.body.clientWidth
        };
    },
    components: {
        navBar
    },
    created() {
        this.getCinemaInfo();
        this.getDateList();
        this.getHotMovieList();
    },
    beforeMount() {},
    mounted() {
        // let movieScroll = document.getElementById("movieScroll");
        // movieScroll.addEventListener('scroll',this.handleScroll,true)
    },
    updated() {
        let movieScroll = document.getElementById("movieScroll");
        if (movieScroll) {
            movieScroll.addEventListener("scroll", this.handleScroll, true);
        }
    },
    watch: {
        activeIdx(val, oldVal) {
            // console.log("activeIdx:", val, oldVal);
            this.movieid = this.hotMovieList[val].id;
            this.getDateList();
            this.selectedIdx = 0;
        }
    },
    methods: {
        handleScroll(e) {
            let movieScroll = document.getElementById("movieScroll");
            let scrollWidth = movieScroll.scrollLeft; // #movieScroll 左滑的距离
            let scrollIdx = Math.round(
                scrollWidth / ((172 * this.screenWidth) / 750)
            );
            // console.log(scrollWidth, scrollIdx, this.screenWidth)
            this.activeIdx = scrollIdx;
            // this.movieid = this.hotMovieList[scrollIdx].id
            // this.getDateList();
        },
        selectMovie(idx) {
            this.activeIdx = idx;
            this.scrollToIdx(idx);
        },
        setActiveIdx() {
            let movieid = this.$route.query.movieid
                ? this.$route.query.movieid
                : "826862";
            for (let i in this.hotMovieList) {
                if (this.hotMovieList[i].id == movieid) {
                    this.activeIdx = i;
                    break;
                } else if (i == this.hotMovieList.length - 1) {
                    if (this.movieid != 1) {
                        Toast({
                            message: "该影院无选中的影片，其他影片一样精彩哦~",
                            position: "middle",
                            duration: 2000,
                            className: "toastBox"
                        });
                    }
                    this.movieid = this.hotMovieList[0].id;
                    this.getDateList();
                }
            }
            this.scrollToIdx(this.activeIdx);
        },
        scrollToIdx(idx) {
            this.$nextTick(() => {
                setTimeout(() => {
                    let movieScroll = document.getElementById("movieScroll");
                    movieScroll.scrollLeft =
                        (172 * idx * this.screenWidth) / 750;
                }, 10);
            });
        },
        // 获取影院信息
        getCinemaInfo() {
            this.$post({
                method: "movie.cinema.detail",
                cinemaid: this.cinemaid
            }).then(res => {
                if (res.success) {
                    this.cinemaInfo = res.data.cinema;
                }
            });
        },
        // 获取影院热门电影
        getHotMovieList() {
            this.$post({
                // method: "movie.hot.list",
                method: "movie.new.hot.list",
                citycode: this.citycode,
                cinemaid: this.cinemaid
            }).then(res => {
                if (res.success && res.data.movielist) {
                    this.hotMovieList = res.data.movielist;
                    this.setActiveIdx();
                }
            });
        },
        // 获取电影播放日期
        getDateList() {
            this.$post({
                // method: "movie.openplay.date.list",
                method: "movie.opi.date.list",
                movieid: this.movieid,
                cinemaid: this.cinemaid
            }).then(res => {
                if (res.success && res.data.datelist) {
                    this.dateList = res.data.datelist;
                    this.getSessionList(this.selectedIdx);
                }
            });
        },
        // 选择电影播放日期
        selectDate(idx) {
            this.selectedIdx = idx;
            this.sessionList = []
            this.getSessionList(idx);
        },
        // 获取电影场次
        getSessionList(idx) {
            Indicator.open("加载中...")
            this.$post({
                method: "movie.openplay.info.list",
                method: "movie.opi.list",
                movieid: this.movieid,
                cinemaid: this.cinemaid,
                playdate: this.dateList[idx]
            }).then(res => {
                Indicator.close()
                if (res.success) {
                    this.sessionList = res.data.opilist;
                }
            });
        },
        //点击购票去选座
        goSelectSeat(info) {
            info.logo = this.hotMovieList[this.activeIdx].logo;
            let movie_info = JSON.stringify(info);
            this.$router.push({
                path: "/selectSeat",
                query: { cinema_name:this.cinemaInfo.name,movie_info: movie_info }
            });
        },
        viewOtherDate() {
            this.selectedIdx = this.selectedIdx + 1;
            this.getSessionList(this.selectedIdx);
        },
        viewLocation(lat,lon,name,address){
            this.$router.push({path: "viewLocation", query: {lat: lat, lon: lon, name: name,address: address}})
        }
    }
};
</script>
<style  lang="scss">
@import "../../../static/css/mixin";
@import "../../../static/css/base";
.cinemaMovieWrap {
    .cinemaInfo {
        height: 132px;
        width: 100%;
        box-sizing: border-box;
        padding: 10px 0 10px 30px;
        background-color: #fff;
        .basicInfo {
            // width: 550px;
            width: 680px;
            height: 112px;
            h3 {
                font-size: 32px;
            }
            p {
                font-size: 24px;
                line-height: 30px;
            }
        }
        .locationIco {
            width: 150px;
            height: 80px;
            margin-left: 20px;
            border-left: 1px solid #ddd;
            img {
                width: 48px;
                height: 48px;
            }
        }
    }
    .scrollWrap {
        position: relative;
        width: 100%;
        height: 300px;
        overflow: hidden;
        .scrollBg {
            position: absolute;
            top: 0;
            right: 0;
            width: 100%;
            height: 120%;
            transform: scale(1.2);
            background-position: center;
            filter: blur(0.3rem);
            overflow: hidden;
            z-index: -10;
        }
        .movieScroll {
            @include scrollBar(300px);
            // background-color: lightblue;
            .movieWrap {
                padding: 25px 0;
                margin: 0 280px;
                height: 300px;
                display: inline-block;
                .activeMovieItem {
                    height: 250px;
                    width: 180px;
                    margin: 0 8px;
                    border: 4px solid #fff; /* no  */
                }
                .movieItem {
                    height: 212px;
                    width: 156px;
                    margin: 0 8px;
                }
            }
        }
    }
    .selectedMoveie {
        width: 100%;
        height: 110px;
        background-color: #fff;
        position: relative;
        span {
            font-size: 26px;
        }
        h3 {
            font-size: 32px;
            z-index: 3;
            span {
                font-size: 28px;
                margin-left: 20px;
                color: #f4ba40;
            }
        }
    }
    .selectedMoveie:before {
        content: "";
        width: 30px;
        height: 30px;
        position: absolute;
        top: -8px;
        left: 50%;
        transform: translateX(-50%) rotate(-45deg);
        background-color: #fff;
        z-index: 2;
    }
    .dateScroll {
        @include scrollBar(90px);
        background: #fff;
        margin-top: 20px;
        border-bottom: 1px solid #efefef; /* no */
        span {
            width: 240px;
            height: 70px;
            line-height: 70px;
            display: inline-block;
            text-align: center;
            margin: 10px;
            border-radius: 10px;
            font-size: 22px;
        }
        .active {
            // color: #fe5200;
            color: #fff;
            background-color: $themeColor;
        }
        .fade {
            color: #999;
            border: 1px solid #999;
        }
    }
    .sessionList {
        height: 140px;
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        background: #fff;
        border-bottom: 1px solid #efefef;
        .timeInfo {
            width: 168px;
            height: 140px;
            .playtime {
                font-size: 36px;
            }
            .closetime {
                font-size: 24px;
            }
        }
        .movieInfo {
            width: 216px;
            height: 140px;
            .edition {
                font-size: 28px;
            }
            .room {
                font-size: 24px;
            }
        }
        .price {
            width: 154px;
            color: $themeColor;
            font-size: 34px;
        }
        .priceInfo {
            .price {
                width: 154px;
                color: $themeColor;
                font-size: 36px;
                // text-align: center;
            }
            .oriPrice {
                font-size: 20px;
                text-decoration: line-through;
                margin: 5px 0;
            }
            .sales {
                font-size: 22px;
                color: $themeColor;
            }
        }
        .btn {
            font-size: 28px;
            color: #fff;
            width: 120px;
            height: 60px;
            // border: 1px solid $themeColor;
            width: 120px;
            border-radius: 10px;
            background: $themeColor;
        }
    }
    .noSession {
        font-size: 28px;
        border-top: 1rpx solid #dededf;
        padding: 60px 0;
        color: #666;
        background-color: #fff;
        button {
            width: 300px;
            height: 60px;
            line-height: 60px;
            background-color: #fff;
            padding: 0 20px;
            color: #666;
            border: 1px solid #bbb;
            margin-top: 30px;
            border-radius: 5px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/movie/cinemaMovieList.vue